const project_name = 'Dino CPP'
const contract_address = "0xc27428de5037efc95653bffec783d5ef94429231";

module.exports = {
    project_name,
    contract_address
}